import React, { useState, useEffect } from 'react';

import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import DeviceType from '../DeviceType';

import cookie from 'react-cookies'
import LightBulb from '../../../assets/img/dashboard/lightBulb';
import LightBulb2 from '../../../assets/img/dashboard/lightBulb2';
import PowerIcon from '../../../assets/img/dashboard/powerLarge';


const LightPanel = ({ selectedItem, handlePower, handlePostData, action }) => {
	const [lightWW] = useState(['LightWw1', 'LightWw2', 'LightWw3']);
	const [lightRGBA] = useState(['LightRgb1', 'LightRgbw2', 'LightRgbw3', "LightRgbw4", 'LightRgbw5', 'LedStripRgb', 'LedStripRgbw1', 'LedStripRgbw2', 'LightRgb4']);
	const [power, setPower] = useState(false);
	const [color, setColor] = useState(null);
	const [color2, setColor2] = useState(null);
	const [brightness, setBrightness] = useState(lightWW.includes(selectedItem.deviceType) ? selectedItem.deviceState.brightness : selectedItem.deviceState.hsvColor.brightness);
	const [temperature, setTemperature] = useState(selectedItem.deviceState.temperature);
	const [hue, setHue] = useState(100);
	const [hex, setHex] = useState("");
	const [, setHsvSat] = useState(0);
	const [, setValue] = useState(0);
	const [hslSat, setHslSat] = useState(0);
	const [, setLight] = useState(brightness / 2);
	const [type, setType] = useState(selectedItem.deviceState.lightMode ? selectedItem.deviceState.lightMode : null);
	const [recentHex, setRecentHex] = useState("");
	const regex = /^#[0-9a-f]{3,6}$/i;
    
	useEffect(() => {
        
        setPower(selectedItem.deviceState.power);

		if (lightWW.includes(selectedItem.deviceType)) {
			const getIndex = selectedItem.deviceState.temperature > 100 ? Math.floor(selectedItem.deviceState.temperature / 20) - 1 : Math.floor(selectedItem.deviceState.temperature / 20);
			setColor(DeviceType.temperature[getIndex]);
			setColor2(DeviceType.temperature2[getIndex]);
            if (selectedItem.deviceState.temperature > 100) {
    			setTemperature(100);
            } else {
    			setTemperature(selectedItem.deviceState.temperature);
            }
			setBrightness(selectedItem.deviceState.brightness ? selectedItem.deviceState.brightness : 0);
			if (selectedItem.deviceState.power && document.querySelector('.custom-range.temperature .input-range__slider')) document.querySelector('.custom-range.temperature .input-range__slider').style.background = DeviceType.temperature[getIndex].replace('0.8', '1');
		} else if (lightRGBA.includes(selectedItem.deviceType)) {

			if (selectedItem.deviceState.hasOwnProperty('lightMode') && selectedItem.deviceState.lightMode && selectedItem.deviceState.lightMode.toLowerCase() === "colour") {
				if (selectedItem.deviceState.hasOwnProperty('hsvColor')) {
					var closest = DeviceType.hueIndex.reduce(function (prev, curr) {
						return (Math.abs(curr - selectedItem.deviceState.hsvColor.hue) < Math.abs(prev - selectedItem.deviceState.hsvColor.hue) ? curr : prev);
					});

					var getType = "colour";
					var getPercentage = DeviceType.hueIndex.indexOf(closest);
					setHue(selectedItem.deviceState.hsvColor.hue);
					setHslSat(selectedItem.deviceState.hsvColor.saturation);
					setBrightness(selectedItem.deviceState.hsvColor.brightness);
					setColor("hsl(" + selectedItem.deviceState.hsvColor.hue + ", " + selectedItem.deviceState.hsvColor.saturation + "%, +" + selectedItem.deviceState.hsvColor.brightness / 2 + "%)");
					colorToHex(selectedItem.deviceState.hsvColor.hue, selectedItem.deviceState.hsvColor.saturation, selectedItem.deviceState.hsvColor.brightness);

					if (document.querySelector('.custom-range.hue .input-range__slider')) {
            document.querySelector('.custom-range.hue .input-range__slider').style.background = "hsl(" + selectedItem.deviceState.hsvColor.hue + ", " + selectedItem.deviceState.hsvColor.saturation + "%, +" + (selectedItem.deviceState.hsvColor.brightness / 2) + "%)"
					}
					if (cookie.load('demo')) {
					} else {
						if (selectedItem.deviceState.powe && document.querySelector('.custom-range.hue .input-range__slider'))
							document.querySelector('.custom-range.hue .input-range__slider').style.background = DeviceType.hue[getPercentage];
					}
					setBrightness(selectedItem.deviceState.hsvColor.brightness >= 100 ? 100 : selectedItem.deviceState.hsvColor.brightness);
					setType(getType.toUpperCase())

				}

			} else if (selectedItem.deviceState.hasOwnProperty('lightMode') && selectedItem.deviceState.lightMode && selectedItem.deviceState.lightMode.toLowerCase() === "white") {
				setColor("#fff");
				setBrightness(selectedItem.deviceState.brightness ? selectedItem.deviceState.brightness : 100);
				setType(selectedItem.deviceState.lightMode.toUpperCase())
			}

		}

	}, [selectedItem, recentHex, selectedItem.deviceState, selectedItem.deviceState.power, type, selectedItem.deviceType, lightRGBA, lightWW, selectedItem.deviceState.lightMode, selectedItem.deviceState.brightness, selectedItem.deviceState.temperature, selectedItem.deviceState.hsvColor?.hue, selectedItem.deviceState.hsvColor?.saturation, selectedItem.deviceState.hsvColor?.brightness]);
    
	const colorToHex = (h, s, v) => {
		var r, g, b;
		h = h / 360;
		s = s / 100;
		v = v / 100;
		var i = Math.floor(h * 6);
		var f = h * 6 - i;
		var p = v * (1 - s);
		var q = v * (1 - f * s);
		var t = v * (1 - (1 - f) * s);
		switch (i % 6) {
			case 0: r = v; g = t; b = p; break;
			case 1: r = q; g = v; b = p; break;
			case 2: r = p; g = v; b = t; break;
			case 3: r = p; g = q; b = v; break;
			case 4: r = t; g = p; b = v; break;
			case 5: r = v; g = p; b = q; break;
			default: break;
		}
		var realRGB = "rgb(" + r * 255 + "," + g * 255 + "," + b * 255 + ")";
		var rgb = realRGB.replace(/[^%,.\d]/g, "").split(",");
		rgb.forEach(function (str, x, arr) {

			/* 컬러값이 "%"일 경우, 변환하기. */
			if (str.indexOf("%") > -1) str = Math.floor(parseFloat(str) * 2.55);

			/* 16진수 문자로 변환하기. */
			str = parseInt(str, 10).toString(16);
			if (str.length === 1) str = "0" + str;

			arr[x] = str;
		});
		var result = "#" + rgb.join("");
		setHex(result);
		setRecentHex(result);
		return result;
	}

	const hexToColor = (value) => {
		setHex(value);
		// 잘못된 값 입력시 이전 hex값 적용
		if (value.length === 7 && !regex.test(value)) {
			value = recentHex;
			setHex(value);
		}
		value = '0x' + value.substring(1, 7);
		let r = (value >> 16) & 0xFF
		let g = (value >> 8) & 0xFF
		let b = value & 0xFF
		r /= 255; g /= 255; b /= 255;
		var max = Math.max(r, g, b);
		var min = Math.min(r, g, b);
		var h, s, v = max;

		var d = max - min;
		s = max === 0 ? 0 : d / max;

		if (max === min) {
			h = 0; // achromatic
		} else {
			switch (max) {
				case r: h = (g - b) / d + (g < b ? 6 : 0); break;
				case g: h = (b - r) / d + 2; break;
				case b: h = (r - g) / d + 4; break;
				default: break;
			}
			h /= 6;
		}
		let HSV = {};
		HSV['h'] = h;
		HSV['s'] = s;
		HSV['v'] = v;

		const max1 = Math.max(r, g, b), min1 = Math.min(r, g, b);
		let h1, s1, l = (max1 + min1) / 2;
		if (max1 === min1) {
			h1 = s1 = 0; // achromatic
		} else {
			let d1 = max1 - min1;
			s1 = l > 0.5 ? d1 / (2 - max1 - min1) : d1 / (max1 + min1);
			switch (max1) {
				case r: h1 = (g - b) / d1 + (g < b ? 6 : 0); break;
				case g: h1 = (b - r) / d1 + 2; break;
				case b: h1 = (r - g) / d1 + 4; break;
				default: break;
			}
			h1 /= 6;
		}
		let HSL = {};
		HSL['h'] = h1;
		HSL['s'] = s1;
		HSL['l'] = l;
		if (value.length === 8) {
			let hexHue = Math.round(h * 360);
			let hexHsvSat = Math.round(s * 100);
			let hexValue = Math.round(v * 100);
			let hexHslSat = Math.round(s1 * 100);
			let hexLight = Math.round(l * 100);
			setHue(hexHue);
			setHsvSat(hexHsvSat);
			setValue(hexValue);

			setHslSat(hexHslSat);
			setLight(hexLight);
			setBrightness(hexValue);
			// 전구 색상 변경
			document.querySelector('.custom-range.hue .input-range__slider').style.background = "hsl(" + hexHue + ", " + hexHslSat + "%, +" + hexLight + "%)";
			setColor("hsl(" + hexHue + ", " + hexHslSat + "%, +" + hexLight + "%)");
			setRecentHex(value);
			var data = {
				"hue": hexHue,
				"saturation": hexHsvSat,
				"brightness": hexValue
			}
			handlePostData("hsvColor", data)
		}
	}

	const handleBrightness = (data) => {
		setLight(Number(data) / 2);
		setBrightness(Number(data));
		if (selectedItem.deviceState.lightMode && selectedItem.deviceState.lightMode.toLowerCase() !== "white") {
			setColor("hsl(" + hue + ", +" + hslSat + "%, " + 50 + "%)")
		}
	}

	const handleHue = (data) => {
		data = Math.round((data / 100) * 360);
		setHue(data);
		document.querySelector('.custom-range.hue .input-range__slider').style.background = "hsl(" + data + ", 100%, +" + (brightness / 2) + "%)";
		setColor("hsl(" + data + ", 100%, 50%)");
	};

	const handleTemperature = (data) => {
		setTemperature(data);
		var getIndex = data > 89 ? Math.round(data / 20) - 1 : Math.round(data / 20);
		document.querySelector('.custom-range.temperature .input-range__slider').style.background = DeviceType.temperature[getIndex].replace('0.8', '1');
		setColor(DeviceType.temperature[getIndex]);
	}

	const changeType = (type) => {
		if (type === "WHITE") {
			handlePostData("lightMode", "white");
			setColor('#fff');
		} else {
			handlePostData("lightMode", "colour")
			var getIndex = hue === 100 ? Math.round(hue / 10) - 1 : Math.round(hue / 10);
			setColor(DeviceType.hue[getIndex]);
		}
		setType(type);
		action();
	}

	const handleCompleteBrightness = (value) => {
		if (type === "COLOUR") {
			handleCompleteHue(hue)
		} else {
			handlePostData("brightness", Number(value))
		}
		action();
	}
	const handleCompleteHue = (value) => {
		var getHue = color && color.split('hsl(')[1];
		getHue = getHue ? getHue.split(',')[0] : 0;

		var data = {
			"hue": Math.round(Number(getHue)),
			"saturation": 100,
			"brightness": brightness
		}
		colorToHex(data.hue, data.saturation, data.brightness);
		handlePostData("hsvColor", data)
		action()
	}
	const handleCompleteTemperature = (value) => {
		handlePostData("temperature", Number(value))
		action()
	}
	const handleLightPower = () => {
		setPower(!power)
		handlePower(selectedItem);
		action();
	}
 
	return (
		<>
			<section className="device-setting-body">
				<div className="device-display">
					{selectedItem.deviceType.indexOf('Ww') === -1 && <ul>
						<li className={type === "WHITE" ? "active" : ""}>
							{selectedItem.deviceState.power &&
								<span>화이트</span>
							}
						</li>
						<li className={type === "COLOUR" ? "active" : ""}>
							{selectedItem.deviceState.power &&
								<span>컬러</span>
							}
						</li>
					</ul>}
					<div className={lightWW.includes(selectedItem.deviceType) ? "temperature-display" : ""}>
						{lightWW.includes(selectedItem.deviceType) && power &&
							<LightBulb2
								key={selectedItem.id + "temp"}
								color={color}
								color2={color2}
								brightness={brightness}
							/>
						}
						{!lightWW.includes(selectedItem.deviceType) && power &&
							<LightBulb
								key={selectedItem.id + "hue"}
								color={color}
								brightness={brightness}
							/>
						}
						{(power === "off" || power === false) &&
							<LightBulb color={'#8A8B8D'} brightness={brightness} />}
					</div>
				</div>
				<div className="device-control-wrap">
					{selectedItem.deviceType.indexOf('Ww') === -1 && selectedItem.deviceState.power &&
						<div className="device-switch">
							<p onClick={() => changeType("WHITE")}>화이트</p>
							<p onClick={() => changeType("COLOUR")}>컬러</p>
						</div>}
					{power && <div className="device-control">
						{type === "COLOUR" && !selectedItem.deviceState.hasOwnProperty("temperature") &&
							<div className="hue custom-range">
								<InputRange
									onChangeComplete={(value) => handleCompleteHue(value)}
									maxValue={100}
									minValue={0}
									value={(hue / 360) * 100}
									onChange={handleHue}
								/>
								<div className="color" tabIndex="1">
									<p>색상 :
									<input
										maxLength="7"
										placeholder="#000000"
										className="hex"
										type="text"
										value={hex}
										onChange={(e) => hexToColor(e.target.value)}
									/>
									</p>
								</div>
							</div>
						}
						{lightWW.includes(selectedItem.deviceType) &&
							<div className="temperature custom-range">
								<InputRange
									onChangeComplete={(value) => handleCompleteTemperature(value)}
									maxValue={100}
									minValue={0}
									value={temperature}
									onChange={handleTemperature}
								/>
								<p>색온도 : {Math.floor((temperature * (65 - 30) / 100) + 30)}00K</p>
							</div>
						}
						<div className="brightness custom-range">
							<InputRange
								onChangeComplete={(value) => handleCompleteBrightness(value)}
								maxValue={100}
								minValue={0}
								value={brightness}
								onChange={handleBrightness}
							/>
							<p>밝기 : {brightness}%</p>
						</div>
					</div>}
				</div>
			</section>
			<section className="device-setting-footer">
				<div className="device-button">
					<button onClick={handleLightPower}>
						<PowerIcon /> 전원
				</button>
				</div>
			</section>
		</>
	);
}

export default LightPanel;